import { Icon } from 'common/icon';
import { Button } from 'common/new-button';
import { Avatar } from 'components/template/publication/comment';
import { Routes } from 'constants/routes';
import { IBlogPost, IComment } from 'constants/types';
import Image from 'next/image';
import Link from 'next/link';
import { formatCreatedAtDate } from 'utils/formatDays';
import styles from './styles.module.css';

interface Props {
  comment: IComment;
}

const CommentSection = ({ comment }: Props) => {
  const { user } = comment ?? {};

  return (
    <div className={styles.commentSection}>
      <Avatar width={56} height={56} src={user?.imageUrl ?? ''} alt={''} />
      <div className={styles.commentContent}>
        <h3 className={styles.userName}>{user?.username}</h3>
        <div className={styles.commentWrapper}>
          <p className={styles.commentText}>{comment?.message}</p>
          <Button text="Reply" className={styles.replyButton} />
        </div>
      </div>
    </div>
  );
};

interface LastBlogProps {
  comment?: IComment;
  blog: IBlogPost;
}

const LastTopics = ({ blog, comment }: LastBlogProps) => {
  return (
    <Link href={Routes.dynamicBlogPage(blog)} className={styles.container}>
      <div className={styles.articleWrapper}>
        <div className={styles.imageColumn}>
          <Image
            width={362}
            height={239}
            src={blog.imageUrl}
            alt="Article featured image"
            className={styles.articleImage}
          />
        </div>
        <div className={styles.contentColumn}>
          <div className={styles.articleContent}>
            <div className={styles.articleMeta}>
              <time className={styles.date}>
                {formatCreatedAtDate(blog.createdAt)}
              </time>
              <span className={styles.separator}>-</span>
              <span className={styles.category}>{blog.category}</span>
              <span className={styles.separator}>-</span>
              <div className={styles.commentsCount}>
                <Icon.Message fillOpacity="0.4" />
                <span className={styles.commentNumber}>
                  {blog.commentsCount ?? 0}
                </span>
              </div>
            </div>
            <h2 className={styles.articleTitle}>{blog.title}</h2>
            {comment?.user?.username?.length && (
              <>
                <p className={styles.bestCommentLabel}>{'Best comment'}</p>
                <CommentSection comment={comment} />
              </>
            )}
          </div>
        </div>
      </div>
      <hr className={styles.separatorLine} />
    </Link>
  );
};

interface NewsArticleContainerProps {
  blogs: IBlogPost[];
  title?: string;
  category?: string;
}
export const NewsArticleContainer = ({
  blogs,
  title = 'Last',
  category,
}: NewsArticleContainerProps) => {
  return (
    <div>
      <h2 className={styles.title}>{`${title} ${category}`}</h2>
      <div className={styles.news_article__wrapper}>
        {blogs.map((blog) => (
          <LastTopics key={blog._id} blog={blog} comment={blog.lastComment} />
        ))}
      </div>
    </div>
  );
};
